import React, {useContext, useEffect, useState} from "react";
import "../CSS Files/tooglebar.css";
import {CreationContext} from "../../../../containers/Content/CreationSuite";
import { fabric } from 'fabric';
import {TextField} from "@material-ui/core";
import Images from "../Images";

export function LoadStockImages (props) {
    const {value} = useContext(CreationContext);
    const [creationCanvas, setCreationCanvas]= value;
    const [stockImages, setStockImages] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [selectedImage, setSelectedImage] = useState("")
    const [pageNum, setPageNum] = useState(1);


    useEffect(() => {
        setStockImages(getImages)
        fabric.Image.fromURL(selectedImage, function (myImg) {
            creationCanvas.add(myImg);
        }, {crossOrigin: 'anonymous'});
        creationCanvas.renderAll();
    }, [selectedImage, searchTerm, pageNum])

    const getImages = () => {
        if(searchTerm!==""){
            fetch('https://pixabay.com/api/?key=25652723-1f2efe85d42131f512d8800a1&image_type=photo&safesearch=true&q='+searchTerm+'&page='+pageNum)
                .then(response => response.json())
                .then(data =>{
                    const listItems = []
                    for(const [value] of data.hits.entries())
                        {
                            listItems.push(data.hits[value].largeImageURL);
                        }
                    setStockImages(listItems);
                });
        }else {
            fetch('https://pixabay.com/api/?key=25652723-1f2efe85d42131f512d8800a1&image_type=photo&safesearch=true&page='+pageNum)
                .then(response => response.json())
                .then(data => {
                    const listItems = []
                    //console.log(data.hits)
                    for (const [value] of data.hits.entries()) {
                        //console.log(data.hits[value].largeImageURL)
                        listItems.push(data.hits[value].largeImageURL);
                    }
                    setStockImages(listItems);

                });
        }

    }

    return (
        <div className="sidebar">
            <div className="search-outer-wrapper">
            <div className="search-wrapper">
            <label className="search-bar-label">
                    Search:
            </label>
            <TextField
                    className="search-bar"
                    id="search-text-field-images"/>
                <button className="search-bar-button"
                    onClick={() => setSearchTerm(document.getElementById("search-text-field-images").value)}>
                    Search
                </button>
            </div>
            <div className="stock-image">
                {stockImages ? stockImages.map((listItems, i)=>
                <div key={i} className="stock-image-toggle">
                <img name="image" src={listItems} alt ={""} width="80%" height="10%" onClick={() => setSelectedImage(listItems)}>
                </img>
                </div>) : null}
            </div>
        </div>

                {
                pageNum > 1 ?
                        <div className="stock-action">
                        <h4 className="inner-action-left"
                                onClick={() => setPageNum(pageNum - 1)}>
                                Prev Page
                            </h4>
                            <h4 className="inner-action-right"
                                onClick={() => setPageNum(pageNum + 1)}>
                                Next Page
                            </h4>
                        </div>
                        : <div className="text-load-stock">
                            <h4 className="load-text"
                                onClick={() => setPageNum(pageNum + 1)}>
                                Next Page
                            </h4>
                        </div>
                }
            
        </div>
        

    )

}
export default Images;
